import clsx from "clsx";

import { Tag } from "@transfr-inc/dashboard-components";

import { AddDeviceTagDropdown } from "./add-device-tag.dropdown";

import "./device.tags.scss";

export const DeviceTags = ({
  className,
  values,
  availableValues,
  onChange,
  onCreateTag,
}) => {
  const onRemoveHandler = (tagId) => {
    const updated = values.filter((v) => tagId !== v.id);
    onChange?.(updated);
  };

  return (
    <div className={clsx("device-tags-container", className)}>
      {values?.map((v) => (
        <Tag
          key={v.id}
          id={v.id}
          color={v.color}
          value={v.value}
          onRemove={onRemoveHandler}
        />
      ))}
      <AddDeviceTagDropdown
        onChange={onChange}
        onCreateTag={onCreateTag}
        tags={availableValues}
        selected={values}
      />
    </div>
  );
};
